module.exports = __webpack_public_path__ + "img/mn.1ef812fb.svg";